import reducer from "./reducers";
import * as ticketRestaurantOperations from "./operations";
import * as ticketRestaurantSelector from "./selectors";

export { ticketRestaurantOperations, ticketRestaurantSelector};

export default reducer;
